module.exports = __webpack_public_path__ + "img/euro.83f79164.svg";